<template>
  <v-app :class="{ 'filters-loading': filtersStore.isLoading }">
    <ChipsFilters />
    <PlaceFilters />
    <LpuTypeFilters />
    <TimeWorkFilters />
    <DoctorSpecialityFilters />
    <ClubSwitchFilters />
    <HighRatingFilters />
    <AppointmentFilters />
    <LpuFilters />
  </v-app>
</template>

<script setup lang="ts">
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import ChipsFilters from 'www/vue_components/common/TheFilters/lpu/components/ChipsFilters/ChipsFilters.vue'
import PlaceFilters from 'www/vue_components/common/TheFilters/lpu/components/PlaceFilters/PlaceFilters.vue'
import LpuTypeFilters from 'www/vue_components/common/TheFilters/lpu/components/LpuTypeFilters/LpuTypeFilters.vue'
import TimeWorkFilters from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/TimeWorkFilters.vue'
import DoctorSpecialityFilters from 'www/vue_components/common/TheFilters/lpu/components/DoctorSpecialityFilters/DoctorSpecialityFilters.vue'
import HighRatingFilters from 'www/vue_components/common/TheFilters/lpu/components/HighRatingFilters/HighRatingFilters.vue'
import AppointmentFilters from 'www/vue_components/common/TheFilters/lpu/components/AppointmentFilters/AppointmentFilters.vue'
import ClubSwitchFilters from 'www/vue_components/common/TheFilters/lpu/components/ClubSwitchFilters/ClubSwitchFilters.vue'
import LpuFilters from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/LpuFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'
import type {
  Url,
  Town,
  DomNodes,
  LpuList,
} from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore.types'

const props = defineProps<{
  initCommonStore: {
    url: Url
    town: Town
    domNodes: DomNodes
    lpuList: LpuList
  }
  initFiltersStore: Filters
}>()

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

commonStore.updateUrl(props.initCommonStore.url)
commonStore.updateTown(props.initCommonStore.town)
commonStore.updateDomNodes(props.initCommonStore.domNodes)
commonStore.updateLpuList(props.initCommonStore.lpuList)

filtersStore.updateFilters(props.initFiltersStore)
</script>

<style lang="scss" scoped>
.filters-loading {
  opacity: .5;
  pointer-events: none;
}
</style>
